export * from './alert.service';
export * from './authentication.service';
export * from './user.service';
export * from './otp.service';
export * from './verifystudent.service';
export * from './photoauth.service';
export * from './lunchpage.service';
export * from './exam.service';
export * from './notification.service';
export * from './opentok.service';


